import { useEffect, useState } from "react";
import { useProviderContext } from "../context/providerContext";
import FrontEndTable from "../../table/FrontEndTable";
import { useApiClient } from "../../../shared/customHooks";
import ComponentHeader from "../../componentHeader/componentHeader";
import userLinkListTable from "../../../shared/tableObjects/userLinkListTable";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import InviteUserComponent from "../../inviteUser/InviteUserComponent";
import { useGlobalContext } from "../../../shared/GlobalContext";

export default function ManageProviderUsersComponent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setHeaderText({
      value: "View Provider",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  const [users, setUsers] = useState<any[]>([]);
  const { id, setHeaderText, providerBase } = useProviderContext();
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  const { fetchData } = useApiClient("UserManagement", { identity: true });
  useEffect(() => {
    fetchData(`getInvitedUsers/${id}`, { discriminator: 1 }).then((res: any) => {
      setUsers(res.data);
    });
  }, []);

  const handleHide = (status: any) => {
    if (status == true) {
      setVisible(false);
    }
  };

  const data = {
    id: id,
    providerBase: providerBase,
  };

  return (
    <>
      {" "}
      <div className="flex flex-column align-items-start w-full p-5 pl-container">
        <ComponentHeader label={"Authorised Representative Management"} />

        <div>
          {isManager && (
            <>
              <div className="flex flex-column">
                <Button
                  tooltip="Invite User to Provider"
                  label="Invite User"
                  className="invite-button mt-2 mb-3"
                  onClick={() => setVisible(!visible)}></Button>{" "}
                <span className="text-left fieldadv mb-5 ">
                  Select this button to send an invitation to a KIS Provider user to create a KIS portal account
                </span>
              </div>
            </>
          )}
          <Dialog
            header="Invite User"
            visible={visible}
            style={{ width: "50vw" }}
            className="z-top modal-styles invite-user"
            onHide={() => setVisible(false)}>
            <InviteUserComponent data={data} onInvite={handleHide}></InviteUserComponent>
          </Dialog>
        </div>
        <div className="sectionHeaderTable">
          <span>Authorised Representative</span>
        </div>
        <FrontEndTable columns={userLinkListTable(isManager)} data={users} header="" />
      </div>
    </>
  );
}
